module.exports = __webpack_public_path__ + "img/error@2x.0c56807e.png";